export const heroStats = [
  { label: "累计话题", value: "4.8万+" },
  { label: "精选热评", value: "21.3万" },
  { label: "活跃瓜友", value: "36万+" },
  { label: "日均讨论", value: "9.6万" },
];

export const navLinks = [
  { label: "热议榜单", href: "#hot" },
  { label: "话题分类", href: "#topics" },
  { label: "观点广场", href: "#reviews" },
  { label: "争议观察", href: "#debate" },
  { label: "最新动态", href: "#news" },
  { label: "讨论指南", href: "#guide" },
  { label: "关于我们", href: "#about" },
];

export const hotTopics = [
  { title: "热播剧收官口碑反转：烂尾还是神结局？", tag: "影视剧综", heat: "1286.4万", comments: "2.3万", trend: "up", badge: "热" },
  { title: "头部主播带货翻车，这届消费者还买账吗", tag: "互联网观察", heat: "984.2万", comments: "1.7万", trend: "up", badge: "热" },
  { title: "综艺后期剪辑引导风向，算不算带节奏", tag: "影视剧综", heat: "863.9万", comments: "1.2万", trend: "up", badge: "争" },
  { title: "新人艺人靠作品还是靠人设持续圈粉", tag: "明星八卦", heat: "742.5万", comments: "9.8千", trend: "flat", badge: "聊" },
  { title: "演唱会门票秒空，黄牛乱象到底怎么治", tag: "生活热梗", heat: "618.3万", comments: "8.6千", trend: "down", badge: "吵" },
  { title: "“纯爱战神”刷屏背后的情感叙事热", tag: "生活热梗", heat: "503.7万", comments: "6.4千", trend: "up", badge: "梗" },
  { title: "国家队新星表现亮眼，饭圈化该不该担忧", tag: "体育电竞", heat: "447.1万", comments: "5.9千", trend: "flat", badge: "议" },
  { title: "平台“搬运警告”频出，二创还有活路吗", tag: "互联网观察", heat: "392.8万", comments: "4.7千", trend: "up", badge: "争" },
];

export const categories = [
  { icon: "ri-film-line", name: "影视剧综", desc: "口碑反转、热剧收官与综艺争议", count: "1.2万个话题" },
  { icon: "ri-user-star-line", name: "明星八卦", desc: "艺人动态、人设观察与作品讨论", count: "9800个话题" },
  { icon: "ri-chat-smile-2-line", name: "生活热梗", desc: "网络热词、情感叙事与圈层文化", count: "7600个话题" },
  { icon: "ri-shield-flash-line", name: "互联网观察", desc: "平台规则、电商直播与内容生态", count: "5300个话题" },
  { icon: "ri-trophy-line", name: "体育电竞", desc: "赛事热点、选手表现与观赛文化", count: "4100个话题" },
  { icon: "ri-earth-line", name: "社会话题", desc: "公共事件里的多元声音与理性讨论", count: "2900个话题" },
];

export const featuredReviews = [
  {
    topic: "热播剧收官口碑反转",
    user: "橘子汽水不加冰",
    role: "追剧派",
    avatar: "橘",
    comment: "前二十集我一天刷完，最后两集我缓了三天。不是烂尾，是前面给的期待太高，收尾想讲的东西太多反而仓促。但我愿意给编剧一个公道：敢把主角写成不完美，本身就是诚意。",
    agree: "1.8万",
    against: "6200",
    hot: "火",
  },
  {
    topic: "主播带货翻车",
    user: "理性买手阿哲",
    role: "消费观察",
    avatar: "哲",
    comment: "翻车不可怕，可怕的是道歉只对镜头不对消费者。大家反感的是“我错了我改了”这种万能公式，真正要的是退款流程透明、选品标准可查。不然热度一过，下次照样踩坑。",
    agree: "1.2万",
    against: "4300",
    hot: "赞",
  },
  {
    topic: "二创剪辑版权之争",
    user: "剪映十级选手",
    role: "创作者",
    avatar: "剪",
    comment: "平台一边靠二创养流量，一边发搬运警告，等于既当裁判又当运动员。要规范我不反对，但规则得讲清楚什么是侵权、什么是合理引用，不能全凭后台一键下架。",
    agree: "9600",
    against: "5100",
    hot: "议",
  },
  {
    topic: "新人艺人靠什么圈粉",
    user: "路过的颜控",
    role: "围观群众",
    avatar: "路",
    comment: "人设能带你火一阵，作品才能留得住人。短期靠颜值和营销可以，但我不爱看千篇一律的营业照，更想看舞台上真正扎实的表现，那才是圈粉的硬通货。",
    agree: "7400",
    against: "2800",
    hot: "聊",
  },
];

export const debate = {
  badge: "本周争议观察",
  title: "二创二次剪辑视频，到底算“创作”还是“搬运”？",
  summary: "一边是创作者靠混剪、解说积累了几十万粉丝，一边是版权方接连发出的搬运警告与下架通知。平台、版权方与普通观众的看法分歧越来越大，成为本周讨论最激烈的话题。",
  data: [
    { camp: "支持方", title: "二创是有价值的内容生产", tone: "yes", points: ["为冷门作品带去曝光，本质是再传播而非窃取", "多数二创加入解说、观点与再编排，具备独创性", "版权方应区分恶意搬运与良性二创，一刀切会误伤" ] },
    { camp: "反对方", title: "未经授权就是侵权搬运", tone: "no", points: ["流量和收益都建立在他人版权作品之上", "解说与混剪不能抹去对原片内容的商业使用", "平台应建立明确授权通道而非事后救火" ] },
  ],
  poll: { yes: "支持方 46%", no: "反对方 38%", mid: "看情况 16%" },
};

export const newsItems = [
  { title: "新一季音乐综艺阵容官宣，导师人选引两派争论", tag: "影视剧综", time: "8分钟前", replies: "328" },
  { title: "某电商大促宣传口径被指“先涨后降”，讨论升温", tag: "互联网观察", time: "26分钟前", replies: "502" },
  { title: "电竞选手转会消息落地，粉丝在评论区吵翻了", tag: "体育电竞", time: "1小时前", replies: "417" },
  { title: "“松弛感”成热词，网友吵它到底是不是假象", tag: "生活热梗", time: "2小时前", replies: "289" },
  { title: "年度剧集盘点出炉，多部口碑剧意外落榜引热议", tag: "影视剧综", time: "3小时前", replies: "356" },
  { title: "短视频平台调整弹幕功能，创作者怎么看", tag: "互联网观察", time: "5小时前", replies: "244" },
];

export const faqs = [
  {
    q: "怎么参与宿野吃瓜的话题讨论？",
    a: "在任意话题卡片点击“参与讨论”，即可进入对应话题发表你的看法；想先看看气氛的话，点“围观评论”浏览各路观点，再决定要不要下场发言。",
  },
  {
    q: "发帖和评论有哪些规范？",
    a: "围绕话题理性表达、就事论事，避免人身攻击与情绪化刷屏；转载他人观点请注明来源。平台欢迎不同观点碰撞，但反对无证据的造谣抹黑与恶意引战。",
  },
  {
    q: "遇到疑似不实信息或违规内容怎么处理？",
    a: "可点击内容旁的举报按钮提交，也可通过页面底部的“意见反馈”表单告知我们。核实后我们会第一时间处理，并反馈处理结果。",
  },
  {
    q: "为什么有些热评会被折叠或隐藏？",
    a: "被折叠的内容通常涉及刷量、辱骂、广告或与话题无关的灌水。折叠是为了让真正有价值的观点获得更多曝光，属于社区秩序维护的正常操作。",
  },
  {
    q: "宿野吃瓜的内容立场是什么？",
    a: "宿野吃瓜是观点聚合与讨论社区，客观呈现不同网友的热评与争议焦点。站内内容仅代表用户个人观点，不代表平台立场，我们也不对未经证实的传闻轻易下结论。",
  },
];

export const testimonials = [
  { name: "夜航西飞", tag: "冲浪老玩家", avatar: "夜", rating: 5, text: "别的平台都在输出情绪，宿野吃瓜至少把同一件事的两派观点都摆出来了，看完能自己判断，而不是被单方面带跑。" },
  { name: "追剧不追星", tag: "剧集党", avatar: "追", rating: 5, text: "热榜更新够快，一部剧刚收官讨论就刷屏了，评论区质量也比想象中高，能翻到很多言之有物的长评。" },
  { name: "潜水型选手", tag: "常年围观", avatar: "潜", rating: 4, text: "我基本只围观不发言，就爱看不同观点来回掰扯。版规也写得清楚，翻车和引战的帖子被处理得挺及时。" },
];

export const rules = [
  { icon: "ri-chat-1-line", title: "就事论事", desc: "讨论聚焦观点本身，对事不对人，礼貌表达不同意见。" },
  { icon: "ri-questionnaire-line", title: "反对造谣", desc: "不传播未经证实的传闻，转载观点请给出依据与来源。" },
  { icon: "ri-flag-2-line", title: "拒绝引战", desc: "不搞人身攻击、不刷屏灌水，让有效观点获得更多曝光。" },
  { icon: "ri-eye-line", title: "多方视角", desc: "欢迎站到对面看看，理解立场背后的理由再表态。" },
];